import React, { Component } from "react";

import _ from "i18n";
import { Header } from "tamtam-components";
import {
  APP_ENV,
  TTP_DASHBOARD_URL,
  TTP_EMAILING_URL,
  TTP_HOME_URL
} from "../../config";
import { push } from "react-router-redux";
import {
  setAuth,
  setLanguage,
  setSwitchSpace,
  setFilterCollaborators,
  setBackOffice
} from "Actions";
import { setCurrentOrganization, fetchFiduciaryData } from "Thunks";
import {
  setLocalStorageCookie,
  clearAllCookies,
  redirectToHome,
  isManagerAccess
} from "Utils";
import { getCookie, setCookie } from "../../utils";

export default class MenuContent extends Component {
  constructor(props) {
    super(props);
    const cookie = getCookie("SWITCH_USER");
    if (this.props.loggedAs === "MANAGER")
      if (cookie) this.props.dispatch(setSwitchSpace(cookie));
    this.state = {
      switchUser: cookie ? cookie : "MANAGER",
      idUserExist: false
    };
  }

  render() {
    const {
      allowAccessToSettings,
      loggedAs,
      user,
      userOrganizations,
      currentOrganization,
      appsState,
      lng,
      currentNavPage,
      token,
      backOffice
    } = this.props;

    // const currentMenus = MENUS[loggedAs];

    //  let hideMenu = HIDDEN_MENU_PAGES.indexOf(currentNavPage) !== -1;

    let portalConfig =
      appsState && appsState.filter(app => app.code === "portal");

    let settingEnabled =
      loggedAs === "MANAGER" ||
      (user && (user.type === "ADMIN" || user.type === "ADMIN_SUPERVISOR"));

    let backOfficeEnabled =
      user && (user.type === "ADMIN" || user.type === "ADMIN_SUPERVISOR");

    let settings = settingEnabled
      ? !backOffice
        ? [
            {
              label: _("users"),
              url: "/authorizations"
            },
            {
              label: _("manageAssociations"),
              url: "/associate-dashboards"
            },
            {
              label: _("manageCategories"),
              url: "/annexe-categories"
            },
            {
              label: _("manageExplanation"),
              url: "/indicators-explanation"
            },
            {
              label: _("extraSlides"),
              url: "/extra-slides"
            }
          ]
        : [
            {
              label: _("manageAssociations"),
              url: "/associate-dashboards"
            },
            {
              label: _("manageCategories"),
              url: "/annexe-categories"
            }
          ]
      : [];
    const switchSpace = {
      items: [
        {
          key: "COLLABORATOR",
          label: _("collaboratorSpace")
        },
        {
          key: "MANAGER",
          label: _("managerSpace")
        }
      ],
      current: this.state.switchUser,
      onChange: user => {
        if (user === "COLLABORATOR") {
          this.props.dispatch(push("/collaborator-space"));
        } else {
          this.props.dispatch(push("/"));
        }
        this.setState({ ...this.state, switchUser: user });
        this.setCookieSwitchUser(user);
        this.props.dispatch(setSwitchSpace(user));
      }
    };
    const rightIcons = {
      ebox: { activated: true, icon: "Ebox", url: `${TTP_EMAILING_URL}e_box` },
      notifs: { activated: true },
      faq: { activated: true },
      apps: {
        activated: true
      },
      home: {
        activated: true,
        icon: "Portal",
        url: portalConfig && portalConfig[0] && portalConfig[0].url
      },
      profile: {
        activated: true,
        url: `${TTP_HOME_URL}/profile`,
        icon: "Profile"
      },
      search: { activated: false },
      backoffice: {
        activated: backOfficeEnabled,
        label: "Back office",
        url: `${TTP_DASHBOARD_URL}/?back_office`,
        clicked: getCookie(`BACK_OFFICE`) === "true"
      }
    };
    if (!user || !user.id) {
      return currentNavPage !== "DASHBOARD_PAGE_COMPOSITION" &&
        currentNavPage !== "DIAPORAMA_PAGE" &&
        currentNavPage !== "PREPARE_PRESENTATION_PAGE" ? (
        <Header
          app={{
            appName: "Accounting",
            appLogoUrl: "https://s3.tamtam.pro/v2/apps/accounting.png",
            appUrl: "/",
            homeUrl: "/"
          }}
          auth={{ navCommunity: null, user: null }}
          lng={lng}
          env={APP_ENV}
          onLanguageChange={lang => this.changeLng(lang)}
          rightIcons={rightIcons}
          onSelectCommunity={community => this.selectCommunity(community)}
        />
      ) : (
        ""
      );
    }
    return currentNavPage !== "DASHBOARD_PAGE_COMPOSITION" &&
      currentNavPage !== "DIAPORAMA_PAGE" &&
      currentNavPage !== "PREPARE_PRESENTATION_PAGE" ? (
      <Header
        auth={{
          token,
          navCommunity: currentOrganization,
          user: {
            ...user,
            communities: !backOffice ? userOrganizations : null
          }
        }}
        env={APP_ENV}
        switchSpace={
          isManagerAccess(loggedAs) && !backOffice ? switchSpace : ""
        }
        lng={lng}
        onLanguageChange={lang => this.changeLng(lang)}
        rightIcons={rightIcons}
        app={{
          appName: "Accounting",
          appLogoUrl: "https://s3.tamtam.pro/v2/apps/accounting.png",
          appUrl: `${TTP_DASHBOARD_URL}`,
          homeUrl: "/"
        }}
        settings={
          (isManagerAccess(loggedAs) && allowAccessToSettings) || backOffice
            ? settings
            : ""
        }
        onLogoutClick={e => this.handleLogout(e)}
        onSelectCommunity={community => this.selectCommunity(community)}
        onBackOfficeClick={activate => this.handleBackOffice(activate)}
      />
    ) : (
      ""
    );
  }
  selectCommunity = community => {
    const { dispatch } = this.props;
    dispatch(setCurrentOrganization(community)).then(() => {
      dispatch(push("/"));
      dispatch(fetchFiduciaryData());
    });
    this.props.dispatch(setFilterCollaborators([]));
  };
  handleLogout = e => {
    const { dispatch } = this.props;
    e.preventDefault();
    dispatch(setAuth(null));
    setLocalStorageCookie(null);

    clearAllCookies(redirectToHome);
  };

  changeLng = e => {
    const { dispatch } = this.props;
    dispatch(setLanguage(e));
    window.location.reload();
  };

  handleBackOffice = activate => {
    this.props.dispatch(push("/"));
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j

    setCookie(`BACK_OFFICE`, activate, dtExpire, "/", "tamtam.pro");
    this.props.dispatch(setBackOffice(activate));

    if (activate === true) {
      setCookie(`SWITCH_USER`, "MANAGER", dtExpire, "/", "tamtam.pro");
      this.props.dispatch(setSwitchSpace("MANAGER"));
      this.setState({
        switchUser: "MANAGER"
      });
    }
  };

  setCookieSwitchUser = user => {
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
    setCookie(`SWITCH_USER`, user, dtExpire, "/", "tamtam.pro");
  };
}



// WEBPACK FOOTER //
// ./src/components/Menu/MenuContent.js